import { useEffect, useRef } from 'react';

export const useTooltipElements = (
  containerRef: React.RefObject<HTMLDivElement>,
) => {
  const tooltipElementsRef = useRef<HTMLElement[]>([]);

  useEffect(() => {
    if (!containerRef.current) return;
    const elements = Array.from(
      containerRef.current.querySelectorAll(
        '[data-tooltip-title][data-tooltip-content]',
      ),
    ) as HTMLElement[];
    tooltipElementsRef.current = elements;
  }, [containerRef]);

  return tooltipElementsRef;
};
